import { IApiManufactory } from '@tap/data-providers';
import { VerticalTabContent, VerticalTabLabel } from '@tap/mui-ui';
import { Skeleton, Typography } from '@mui/material';
import { DepartmentSelectTree, ExtSector } from '.';


export enum SelectDepartmentTabVariant {
    Tree,
    SingleSelect,
}

export type DeparetmentVerticalTabProps = {
    manufactoryList: IApiManufactory[],
    sectorList: ExtSector[],
    selectedDepartmentIds: number[],
    isLoading: boolean,
    variant?: SelectDepartmentTabVariant,
}

const TabLabel = (props: DeparetmentVerticalTabProps) => {

    const isAllSelected = props.selectedDepartmentIds.length === 0 || props.selectedDepartmentIds.length === props.sectorList.length;
    const chipLabelText = isAllSelected ? 'все' : props.selectedDepartmentIds.length;

    if (props.variant === SelectDepartmentTabVariant.SingleSelect) {

        const selectedDepartmentName = props.sectorList.find(s => s.departmentId === props.selectedDepartmentIds[0])?.fullName;
        return (
            <VerticalTabLabel
                title={'Цех и участок'}
                subTitle={selectedDepartmentName ?? 'не выбран'}
            />
        );
    }

    // Tree
    return (
        <VerticalTabLabel
            title={'Цех и участок'}
            subTitle={<TabTitle {...props} />}
            chipLabel={chipLabelText}
            chipTooltipLabel={chipLabelText}
        />
    );
};


const TabTitle = ({ isLoading, manufactoryList, sectorList }: DeparetmentVerticalTabProps) => {
    if (isLoading) {
        return <Skeleton width='120px' />;
    }


    return <>{`Цехов: ${manufactoryList?.length}, Участков: ${sectorList?.length}`}</>
}


const TabContent = ({ manufactoryList, sectorList, selectedDepartmentIds, onChange }: DeparetmentVerticalTabProps & { onChange: (value: number[]) => void }) => {
    return (
        <VerticalTabContent
            title={'Цех и участок'}
            contentWrapStyle={{
                padding: '5px 0px 0px 5px',
                overflowY: 'scroll',
                height: 'calc(100vh - 330px)',
            }}
        >
            {!manufactoryList?.length && (
                <Typography sx={{ mb: 2 }}>
                    Нет данных
                </Typography>
            )}
            {Boolean(manufactoryList?.length) &&
                <DepartmentSelectTree
                    manufactoryList={manufactoryList}
                    sectorList={sectorList}
                    selectedDepartmentIds={selectedDepartmentIds}
                    onChange={onChange}
                />
            }
        </VerticalTabContent>
    );
}

export const SelectDepartmentVerticalTab = { TabLabel, TabContent }